import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-phone-inprocess.component.ajs.html';

const MODULE_NAME = 'agentBookingPhoneInprocess';

class AgentBookingPhoneInprocessCtrl implements IComponentController {
  public name = MODULE_NAME;

  $onInit() {}
}

export class AgentBookingPhoneInprocess implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingPhoneInprocessCtrl];
}

export default MODULE_NAME;
